module.exports = __webpack_public_path__ + "static/media/all.391d66e4.png";